import {EpLayer} from "./layer";
import {
    inventoryLocationStyle,
} from "../styles/inventory-locations";

export class EpInventoryLocationAreas extends EpLayer {
    constructor(map) {
        super(map);

        this.style = inventoryLocationStyle;
        this.farStyle = null;

        this.title = 'Tereny obserwacji';
        this.name = 'thermal_imaging_areas';

        return this;
    }
}
